import React, { FC } from "react"
import { useSelector } from "react-redux"

import { getSectionChat, getSettings } from "@/onboarding/features/product/selectors"
import { ReservedFields, ReservedSections } from "@/onboarding/features/product/models/Product"

import SectionHolder from "./shared/SectionHolder"
import Content from "./headsets/Content"
import Edit from "./headsets/Edit"

const Headsets: FC = () => {
  const { headset_components } = useSelector(getSettings(ReservedFields.HEADSET_COMPONENTS))
  const sectionChat = useSelector(getSectionChat(ReservedFields.HEADSET_COMPONENTS))

  const isWriteable = headset_components?.writeable ?? false
  const headsetIsChanged = headset_components?.changed ?? false

  const rateSettings = useSelector(getSettings(ReservedFields.HEADSET_FEE_RATESHEET))
  const rateIsChanged = rateSettings[ReservedFields.HEADSET_FEE_RATESHEET]?.changed

  const changedComponent = rateIsChanged || headsetIsChanged

  return (
    <SectionHolder
      title="Headsets"
      name={ReservedSections.HEADSET_COMPONENTS}
      editComponent={isWriteable ? Edit : null}
      editMethod="inline"
      importableFields={[ReservedFields.HEADSET_COMPONENTS, ReservedFields.HEADSET_FEE_RATESHEET]}
      showLockedIcon={!isWriteable}
      changedComponent={changedComponent}
      chat={sectionChat}
    >
      <Content changedComponent={changedComponent} />
    </SectionHolder>
  )
}

export default Headsets
